export const VITE_SUPPORT_TEL: string = Object.freeze(import.meta.env.VITE_SUPPORT_TEL)
export const VITE_SUPPORT_EMAIL: string = Object.freeze(import.meta.env.VITE_SUPPORT_EMAIL)
